<template>
  <b-table
    class="simul-request-table"
    v-if="waitingRequests.length"
    :data="waitingRequests.length ? waitingRequests : []"
    :hoverable="true"
    :focusable="true"
    :width="360"
    :sticky-header="true"
  >
    <b-table-column
      label="Requesting to join"
      cell-class="has-text-left"
      v-slot="{ row: request }"
    >
      <ProfileCard :player="request.player"></ProfileCard>
    </b-table-column>

    <b-table-column cell-class="has-text-left" v-slot="{ row: request }">
      <b-button
        class="is-small is-success"
        :loading="isLoading"
        @click="approve(request)"
      >
        Allow
      </b-button>
      <b-button
        class="is-small is-danger ml-2"
        @click="reject(request)"
        :disabled="isLoading"
      >
        Deny
      </b-button>
    </b-table-column>
  </b-table>
</template>

<script>
import firebase from "firebase/app";
import { firestore } from "@/services/firebase";
import ProfileCard from "@/components/players/ProfileCard.vue";
import { MATCH_DEFAULT, SIMUL_REQUEST_STATUS } from "@/constants";
import joinOrOpenMatchMixin from "@/mixins/joinOrOpenMatchMixin";
import { GAME_OVERRIDE } from "vue-chess-shared/constants";

export default {
  components: { ProfileCard },

  name: "SimulRequestTable",

  mixins: [joinOrOpenMatchMixin],

  props: {
    simulId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      simul: null,
      requests: [],
    };
  },

  computed: {
    waitingRequests() {
      const requests = this.requests.filter(
        (r) => r.status === SIMUL_REQUEST_STATUS.REQUESTED
      );
      return requests;
    },
  },

  methods: {
    async approve(request) {
      this.isLoading = true;

      await this.openMatch(
        request.player,
        this.simul.baseTimeControl * 60,
        MATCH_DEFAULT.INCREMENT,
        MATCH_DEFAULT.VARIANT,
        GAME_OVERRIDE.PVP,
        this.simulId
      );

      await firestore
        .collection("simulRequests")
        .doc(request.id)
        .update({
          status: SIMUL_REQUEST_STATUS.APPROVED,
        });

      await firestore
        .collection("simuls")
        .doc(this.simulId)
        .update({
          players: firebase.firestore.FieldValue.arrayUnion(request.player),
        });

      this.isLoading = false;
    },

    async reject(request) {
      await firestore
        .collection("simulRequests")
        .doc(request.id)
        .update({
          status: SIMUL_REQUEST_STATUS.REJECTED,
        });
    },
  },

  async created() {
    await this.$bind("simul", firestore.collection("simuls").doc(this.simulId));
    await this.$bind(
      "requests",
      firestore.collection("simulRequests").where("simulId", "==", this.simulId)
    );
  },
};
</script>

<style scoped>
.simul-request-table /deep/ .table-wrapper {
  overflow-x: hidden;
  height: auto;
}

.simul-request-table /deep/ .table-wrapper.has-sticky-header {
  height: auto;
  max-height: 300px;
}
</style>
